/* eslint-disable no-unused-vars */
import axios from "../../axios";

const url = "/package";

export default {
  /**
   * Get lists
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getList({ commit }, payload) {
    const response = await axios.get(url, { params: payload });
    if (response.status === 200) {
      commit("SET_LIST", response.data);
    }
    return response;
  },

  async create({ commit }, payload) {
    const response = await axios.post(url, payload);
    if (response.status === 201) {
      commit("CREATE", response.data.data);
    }
    return response;
  },

  async update({ commit }, { id, payload }) {
    const response = await axios.put(url + "/" + id, payload);
    if (response.status === 200) {
      commit("UPDATE", response.data.data);
    }
    return response;
  },

  async delete({ commit }, id) {
    const response = await axios.delete(url + "/" + id);
    if (response.status === 200) {
      commit("DELETE", id);
    }
    return response;
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};
